export const SORT_TYPE_LABEL_OVERRIDES: Record<string, string> = {
  cuboh_modifier_group: 'Group',
  cuboh_modifier: 'Mod',
};

export const SORT_TYPE_LABEL_PLURAL_OVERRIDES: Record<string, string> = {
  cuboh_modifier_group: 'Groups',
  cuboh_modifier: 'Mods',
};
